/**
 * Created by Jack on 2020/3/27.
 */
import Vue from 'vue';

const bus = new Vue();

export  default bus;



// WEBPACK FOOTER //
// ./src/bus.js